import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type TCommandPaletteStore = {
   isAcceptApplicationModalOpen: boolean;
   isApproveApplicationModalOpen: boolean;
   isImagePreviewModalOpen: string | null;
   isLogoutModalOpen: boolean;
   isRejectApplicationModalOpen: boolean;
   isRejectedApplicationModalOpen: boolean;
   isEMIModalOpen: number | null;
   isReverseEMIModalOpen: number | null;
   isCloseApplicationModalOpen: boolean;

   toggleAcceptApplicationModal: (value?: boolean) => void;
   toggleApproveApplicationModal: (value?: boolean) => void;
   toggleImagePreviewModal: (value?: string | null) => void;
   toggleLogoutModal: (value?: boolean) => void;
   toggleRejectApplicationModal: (value?: boolean) => void;
   toggleRejectedApplicationModal: (value?: boolean) => void;
   toggleEMIModal: (value?: number | null) => void;
   toggleReverseEMIModal: (value?: number | null) => void;
   toggleCloseApplicationModal: (value?: boolean) => void;
};
export const useCommandPaletteStore = create<TCommandPaletteStore>()(
   immer((set) => ({
      isAcceptApplicationModalOpen: false,
      isApproveApplicationModalOpen: false,
      isImagePreviewModalOpen: null,
      isLogoutModalOpen: false,
      isRejectApplicationModalOpen: false,
      isRejectedApplicationModalOpen: false,
      isEMIModalOpen: null,
      isReverseEMIModalOpen: null,
      isCloseApplicationModalOpen: false,

      toggleAcceptApplicationModal: (value?: boolean) => {
         set((state) => {
            state.isAcceptApplicationModalOpen =
               value ?? !state.isAcceptApplicationModalOpen;
         });
      },
      toggleApproveApplicationModal: (value?: boolean) => {
         set((state) => {
            state.isApproveApplicationModalOpen =
               value ?? !state.isApproveApplicationModalOpen;
         });
      },
      toggleImagePreviewModal: (value?: string | null) => {
         set((state) => {
            if (value) {
               state.isImagePreviewModalOpen = value;
            } else {
               state.isImagePreviewModalOpen = null;
            }
         });
      },

      toggleLogoutModal: (value?: boolean) => {
         set((state) => {
            state.isLogoutModalOpen = value ?? !state.isLogoutModalOpen;
         });
      },

      toggleRejectApplicationModal: (value?: boolean) => {
         set((state) => {
            state.isRejectApplicationModalOpen =
               value ?? !state.isRejectApplicationModalOpen;
         });
      },

      toggleRejectedApplicationModal: (value?: boolean) => {
         set((state) => {
            state.isRejectedApplicationModalOpen =
               value ?? !state.isRejectedApplicationModalOpen;
         });
      },

      // ID is always greater than 0
      toggleEMIModal: (value?: number | null) => {
         set((state) => {
            if (value) {
               state.isEMIModalOpen = value;
            } else {
               state.isEMIModalOpen = null;
            }
         });
      },

      // ID is always greater than 0
      toggleReverseEMIModal: (value?: number | null) => {
         set((state) => {
            if (value) {
               state.isReverseEMIModalOpen = value;
            } else {
               state.isReverseEMIModalOpen = null;
            }
         });
      },

      toggleCloseApplicationModal: (value?: boolean) => {
         set((state) => {
            state.isCloseApplicationModalOpen =
               value ?? !state.isCloseApplicationModalOpen;
         });
      },
   })),
);
